import * as React from 'react';

export const ArrowTopLeft: React.VFC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 5.31066L4.25 11.5H2.75L2.75 3.5L2.75 2.75L3.5 2.75L11.5 2.75V4.25L5.31066 4.25L13.0303 11.9697L11.9697 13.0303L4.25 5.31066Z"
        fill="#767676"
      />
    </svg>
  );
};
